export default __webpack_public_path__ + "static/media/kstrokeorder.5d218221.png";